//@mui
import { Stack } from '@mui/system';
//reducers
//components
import { Checkbox, Typography, useTheme, Box } from '@mui/material';
import React from 'react';
import { FormInsideCard } from 'theme/elements/Forms';
import { HeaderPage3 } from 'theme/elements/Headers';
//constants
import { BankAccount } from 'constants/bank-account.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { getCurrenciesObj } from 'state/reducers/global.reducers';
import { CustomCheckbox } from 'theme/elements/Inputs';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getMobile } from 'state/reducers/ui.reducers';
import { getAddBalanceState } from 'state/reducers/balance.reducers';
import { BalanceDepositType } from 'constants/balance.constants';

interface BankAccountsProps {
  account: BankAccount;
  handleBankPick: any;
  isSelected: boolean;
}

export default function BankAccountDetails(props: BankAccountsProps) {
  const t = useAppSelector(selectTranslations);
  const { account, isSelected, handleBankPick } = props;
  const currencies = useAppSelector(getCurrenciesObj);
  const isMobile = useAppSelector(getMobile);
  const balanceState = useAppSelector(getAddBalanceState);
  const isUnavailableForDigitalDepositFlow =
    balanceState === BalanceDepositType.Digital && account.bankName.isDigitalDepositTemporarilyUnavailable === true;
  const handleBankChoose = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isUnavailableForDigitalDepositFlow) {
      return;
    }
    handleBankPick(Number(event.target.value));
  };
  const theme = useTheme();

  return (
    <FormInsideCard
      sx={{
        margin: 0,
        opacity: isUnavailableForDigitalDepositFlow ? 0.5 : 1,
        backgroundColor: `${isSelected ? theme.palette.root.brandSecondary_012 : 'inherit'}`,
      }}
      key={`bank-account-${account?.accountNumber}`}
    >
      <Stack direction="row" spacing={3}>
        <CustomCheckbox>
          <Checkbox
            sx={{
              color: '#2C3E50',
              '&.Mui-checked': {
                color: '#ffffff',
              },
              height: 'max-content',
            }}
            checked={isSelected}
            disabled={isUnavailableForDigitalDepositFlow}
            value={account?.id}
            onChange={handleBankChoose}
          />
        </CustomCheckbox>
        <Stack direction="column" width={'100%'}>
          <Stack direction="row">
            <Typography variant="caption" width={'56%'}>
              {account?.accountOwnerName
                ? account?.accountOwnerName
                : t('page.balance.add.step.3.transfer_details.altshuler_accounts_holder_name.text')}
            </Typography>
            <Typography variant="captionRegular" width={'44%'}>
              {account?.currency?.name ? account?.currency.name : currencies[account.currencyId].name}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent={'space-between'}>
            <Typography variant={isMobile ? 'caption' : 'subtitle2'} width={'56%'}>
              {account?.bankName?.bankName.trim()}
            </Typography>
            <Typography variant={isMobile ? 'caption' : 'subtitle2'} width={'21%'} textAlign={'start'}>{account?.bankBranch}</Typography>
            <Typography variant={isMobile ? 'caption' : 'subtitle2'} width={'25%'} textAlign={'end'}>{account?.accountNumber}</Typography>
          </Stack>
        </Stack>
      </Stack>
    </FormInsideCard>
  );
}
